import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import HerissonLogo from "@/components/HerissonLogo";
import BrandBadge from "@/components/BrandBadge";

const FEATURES = [
  { emoji: "🎪", title: "Concerts & spectacles", desc: "Bastian Baker, Sonia Grimm, Cie Jolla… des artistes plein d'énergie.", color: "#F5ACB4" },
  { emoji: "🎨", title: "Ateliers créatifs", desc: "40+ ateliers ludiques, créatifs, sportifs, scientifiques et musicaux.", color: "#A1C861" },
  { emoji: "🍜", title: "Restauration famille", desc: "Cantine, hot-dogs, pasta, desserts maison et boissons locales.", color: "#FEC900" },
  { emoji: "🎁", title: "Bracelet cashless", desc: "Payez rapidement et sans contact avec votre bracelet du festival.", color: "#8389C3" },
];

export default function Home() {
  const [home, setHome] = useState({ tagline1: "Le Paléo des Marmots", tagline2: "29-30 août 2026 - Charrat" });

  useEffect(() => {
    api.get("/config/home").then(({ data }) => setHome(data)).catch(() => {});
  }, []);

  return (
    <div>
      {/* HERO */}
      <section className="relative overflow-hidden">
        <div className="absolute inset-0 pointer-events-none">
          <div className="absolute -top-24 -left-24 w-96 h-96 rounded-full blur-3xl opacity-30" style={{ background: "#5BC5F2" }} />
          <div className="absolute -bottom-24 -right-24 w-96 h-96 rounded-full blur-3xl opacity-25" style={{ background: "#F5ACB4" }} />
        </div>
        <div className="max-w-7xl mx-auto px-4 pt-14 pb-20 relative">
          <div className="grid lg:grid-cols-2 gap-10 items-center">
            <div>
              <BrandBadge color="#A1C861">🌿 Festival famille</BrandBadge>
              <h1 className="mt-4 text-5xl md:text-6xl font-black leading-tight">
                <span className="gradient-text">{home.tagline1}</span>
              </h1>
              <p className="mt-3 text-2xl font-bold text-neutral-200">{home.tagline2}</p>
              <p className="mt-5 text-neutral-300 max-w-lg">
                Deux jours de fête, de découvertes, d'émerveillement et de bonne humeur pour les enfants (0-12 ans) et leurs familles au cœur du Valais.
              </p>
              <div className="mt-8 flex flex-wrap gap-3">
                <Link to="/tickets" className="brand-gradient-btn px-6 py-3 rounded-xl text-base" data-testid="cta-tickets">🎟️ Réserver mes billets</Link>
                <Link to="/programme" className="px-6 py-3 rounded-xl text-base font-semibold bg-neutral-800 hover:bg-neutral-700 text-white" data-testid="cta-programme">🎪 Voir le programme</Link>
              </div>
            </div>
            <div className="flex justify-center relative">
              <div className="card-hsg p-8 max-w-md w-full text-center">
                <HerissonLogo size="xl" className="mx-auto" />
                <p className="mt-6 text-neutral-300 text-sm">
                  Un festival <b>joyeux, gourmand, curieux et durable</b> pour toute la famille.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FEATURE CARDS */}
      <section className="max-w-7xl mx-auto px-4 py-10">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {FEATURES.map((f, i) => (
            <div key={i} className="card-hsg p-6 hover:-translate-y-1 transition-transform">
              <div className="text-4xl mb-3">{f.emoji}</div>
              <h3 className="font-bold text-lg" style={{ color: f.color }}>{f.title}</h3>
              <p className="text-neutral-400 text-sm mt-2">{f.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* INFOS BLOCK */}
      <section className="max-w-7xl mx-auto px-4 py-14">
        <div className="grid md:grid-cols-3 gap-4">
          <div className="card-hsg p-6">
            <div className="chip mb-3" style={{ background: "#5BC5F222", color: "#5BC5F2", border: "1px solid #5BC5F255" }}>📅 Dates</div>
            <h4 className="font-bold text-xl">Samedi 29 & Dimanche 30 août 2026</h4>
            <p className="text-neutral-400 mt-2">10h30 — 20h00 chaque jour</p>
          </div>
          <div className="card-hsg p-6">
            <div className="chip mb-3" style={{ background: "#FEC90022", color: "#FEC900", border: "1px solid #FEC90055" }}>📍 Lieu</div>
            <h4 className="font-bold text-xl">École primaire de Charrat</h4>
            <p className="text-neutral-400 mt-2">Rue de l'École 1, 1906 Charrat, Valais</p>
          </div>
          <div className="card-hsg p-6">
            <div className="chip mb-3" style={{ background: "#E72E4A22", color: "#E72E4A", border: "1px solid #E72E4A55" }}>👶 Public</div>
            <h4 className="font-bold text-xl">Famille & enfants 0–12 ans</h4>
            <p className="text-neutral-400 mt-2">Gratuit pour les 0–2 ans</p>
          </div>
        </div>
      </section>
    </div>
  );
}
